import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermissions';
import { useRouterProps } from '../hooks/useRouterProps';
import { ROUTES } from '@lsgo/lsgo-common/constants/routes';

/**
 * Permission-based route guard
 * Only checks permissions - authentication should be handled by RouteBuilder
 * This guard assumes auth has already been verified
 */
const PermissionRoute = ({
    children,
    render,
    permissions = [],
    requireAll = false,
    redirectTo,
    fallback,
    ...props
}) => {
    const permissionsHook = usePermissions();
    const routerProps = useRouterProps();

    // Check permissions (auth is handled by RouteBuilder)
    if (permissions && permissions.length > 0) {
        const hasAccess = requireAll
            ? permissionsHook.hasAllPermissions(permissions)
            : permissionsHook.hasAnyPermission(permissions);

        if (!hasAccess) {
            return fallback || <Navigate to={redirectTo || ROUTES.AUTH.NO_PERMISSION.path} replace />;
        }
    }

    // All checks passed
    return render ? render({ ...props, ...routerProps }) : children;
};

export default PermissionRoute;
